export default __webpack_public_path__ + "static/media/aka-clouds-new.c50c7635.ogv";